import { warn } from '/@/utils/log'
// import { getConfigFileName } from '../../build/getConfigFileName'

export function getCommonStoragePrefix() {
  const { VITE_GLOB_APP_SHORT_NAME } = getAppEnvConfig()
  return `${VITE_GLOB_APP_SHORT_NAME}__${getEnv()}`.toUpperCase()
}

// Generate cache key according to version
export function getStorageShortName() {
  return `${getCommonStoragePrefix()}${`__${window.__APP_INFO__.pkg.version}`}__`.toUpperCase()
}

export function getAppEnvConfig() {
  // const ENV_NAME = getConfigFileName(import.meta.env)

  // const ENV = (import.meta.env.DEV
  //   ? // Get the global configuration (the configuration will be extracted independently when packaging)
  //     (import.meta.env as unknown as GlobEnvConfig)
  //   : window[ENV_NAME as any]) as unknown as GlobEnvConfig

  const VITE_GLOB_APP_TITLE = import.meta.env.VITE_GLOB_APP_TITLE
  const VITE_GLOB_API_URL = import.meta.env.VITE_GLOB_API_URL
  const VITE_GLOB_APP_SHORT_NAME = import.meta.env.VITE_GLOB_APP_SHORT_NAME
  const VITE_GLOB_API_URL_PREFIX = import.meta.env.VITE_GLOB_API_URL_PREFIX
  const VITE_GLOB_UPLOAD_URL = import.meta.env.VITE_GLOB_UPLOAD_URL
  const VITE_GLOB_APP_ID = import.meta.env.VITE_GLOB_APP_ID
  const VITE_GLOB_REDIRECT_URL = import.meta.env.VITE_GLOB_REDIRECT_URL
  const VITE_GLOB_PASSPOART_URL = import.meta.env.VITE_GLOB_PASSPOART_URL
  const VITE_GLOB_IS_CHECK_ROUTER_AUTH = import.meta.env.VITE_GLOB_IS_CHECK_ROUTER_AUTH
  const VITE_GLOB_WS_URL = import.meta.env.VITE_GLOB_WS_URL
  const VITE_GLOB_IS_USER_CONFIG_USE_CACHE = import.meta.env.VITE_GLOB_IS_USER_CONFIG_USE_CACHE
  const VITE_UPGRADE_OVERVIEW_URL = import.meta.env.VITE_UPGRADE_OVERVIEW_URL
  const VITE_AUTH_APPLICATION_URL = import.meta.env.VITE_AUTH_APPLICATION_URL
  const VITE_UPGRADE_OVERVIEW_DETAIL_URL = import.meta.env.VITE_UPGRADE_OVERVIEW_DETAIL_URL
  const VITE_VEHICLE_VERSION_DISTRIBUTION_URL = import.meta.env
    .VITE_VEHICLE_VERSION_DISTRIBUTION_URL
  const VITE_GLOB_LOGIN_TYPE_SCAN = import.meta.env.VITE_GLOB_LOGIN_TYPE_SCAN
  const VITE_GLOB_LOGIN_TYPE_ACCOUNT = import.meta.env.VITE_GLOB_LOGIN_TYPE_ACCOUNT
  const VITE_GLOB_LOGIN_TYPE_SSO = import.meta.env.VITE_GLOB_LOGIN_TYPE_SSO
  const VITE_GLOB_LOGIN_TYPE_FL = import.meta.env.VITE_GLOB_LOGIN_TYPE_FL
  const VITE_GLOB_SC_API = import.meta.env.VITE_GLOB_SC_API
  const VITE_GLOB_IS_CODE_AUTH_MODE = import.meta.env.VITE_GLOB_IS_CODE_AUTH_MODE

  if (!/^[a-zA-Z\_]*$/.test(VITE_GLOB_APP_SHORT_NAME)) {
    warn(
      `VITE_GLOB_APP_SHORT_NAME Variables can only be characters/underscores, please modify in the environment variables and re-running.`,
    )
  }

  return {
    VITE_GLOB_APP_TITLE,
    VITE_GLOB_API_URL,
    VITE_GLOB_APP_SHORT_NAME,
    VITE_GLOB_API_URL_PREFIX,
    VITE_GLOB_SC_API,
    VITE_GLOB_UPLOAD_URL,
    VITE_GLOB_APP_ID,
    VITE_GLOB_REDIRECT_URL,
    VITE_GLOB_PASSPOART_URL,
    VITE_GLOB_IS_CHECK_ROUTER_AUTH,
    VITE_GLOB_WS_URL,
    VITE_GLOB_IS_USER_CONFIG_USE_CACHE,
    VITE_UPGRADE_OVERVIEW_URL,
    VITE_AUTH_APPLICATION_URL,
    VITE_UPGRADE_OVERVIEW_DETAIL_URL,
    VITE_VEHICLE_VERSION_DISTRIBUTION_URL,
    VITE_GLOB_LOGIN_TYPE_SCAN,
    VITE_GLOB_LOGIN_TYPE_ACCOUNT,
    VITE_GLOB_LOGIN_TYPE_SSO,
    VITE_GLOB_LOGIN_TYPE_FL,
    VITE_GLOB_IS_CODE_AUTH_MODE,
  }
}

/**
 * @description: Development mode
 */
export const devMode = 'development'

/**
 * @description: Production mode
 */
export const prodMode = 'production'

/**
 * @description: Get environment variables
 * @returns:
 * @example:
 */
export function getEnv(): string {
  return import.meta.env.MODE
}

/**
 * @description: Is it a development mode
 * @returns:
 * @example:
 */
export function isDevMode(): boolean {
  return import.meta.env.DEV
}

/**
 * @description: Is it a production mode
 * @returns:
 * @example:
 */
export function isProdMode(): boolean {
  return import.meta.env.PROD
}
